import LetterHead from "./LetterHead";
import ContactMailPhone from "./ContactMailPhone";
import BankAccountAndTaxNumbers from "./BankAccountAndTaxNumbers";

const ProfileContactInfo = ({ language }) => {

  return (
    <>
      <LetterHead />
      <ContactMailPhone language={language} />
      <BankAccountAndTaxNumbers language={language} />
    </>
  );
};

export default ProfileContactInfo;
